App.directive('formUnumAssuredPersonTpl', ['$window', 'Config', '$filter', 'statesService', '$q',
    function ($window, Config, $filter, statesService, $q) {
    return {
    	restrict: 'AEC',
        scope: {
            form: '=',
            model: '=',
            prefix: '@',
            withSibling: '=',
            forWorker: '=?',
            copyAddress: '=?',
            person: '=?',
            key: '='
        },
        templateUrl: Config.TEMPLATES_DIR + 'Components/form-unum-assured-person-tpl.html',
        link: function(scope) {
    	    scope.copyAddress = scope.copyAddress || false;
    	    scope.person = scope.person || null;
    	    scope.showCheckbox = false;

            var getResults = function(query) {
                var deferred = $q.defer();

                statesService.dataCityLists({
                    name: query
                }).then(function(data) {
                    deferred.resolve(data.data);
                });

                return deferred.promise;
            };

            // ##### LOCALIZATION FILTER ##### //
            scope.querySearchLocalization = function(query) {
                if (!query) {
                    return;
                }
                  
                return getResults(query).then(function(results) {
                    return results;
                });
            };
        }
    };
}]);